import React from "react";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled, { createGlobalStyle } from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import wvBackground from "../images/wv_p3.svg"; // Adjust the path as necessary
import istockphoto from '../images/animated/17.png';
 
const GlobalStyle = createGlobalStyle`
  body {
    background-image: url(${wvBackground}), url(${wvBackground});
    background-size: cover, cover;
    background-repeat: no-repeat, no-repeat;
    background-position: 100%, top;
    margin: 0;
    padding: 0;
    font-family: 'Inter', system-ui, sans-serif;
  }

  body::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100vh;
    background-image: url(${wvBackground});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top;
    transform: scaleY(-1);
    z-index: -1;
  }
  
`;
 const Text = styled.div`
  ${tw`text-lg text-gray-700 leading-relaxed mx-auto bg-white rounded-3xl shadow-xl px-6 py-10 sm:px-10 md:px-16 md:py-16`}
  max-width: 52rem;
  background-color: rgba(255, 255, 255, 0.95);
  p {
    ${tw`mt-2`}
  }
  h1 {
    ${tw`text-4xl sm:text-5xl font-black text-secondary-500 leading-tight mb-6`}
  }
  h2 {
    ${tw`text-2xl sm:text-3xl font-bold text-secondary-500 mt-16 mb-4 pl-4 border-l-4 border-primary-500 leading-tight`}
    scroll-margin-top: 2rem;
  }
  h3 {
    ${tw`text-xl font-bold mt-4`}
  }
  a {
    ${tw`text-primary-500 font-semibold underline`}
  }
  ul {
    ${tw`my-6 rounded-2xl px-6 py-4 list-none`}
    background-color: #FAF6F3;
    li {
      ${tw`py-3 pl-6 relative`}
      &:not(:last-child) {
        border-bottom: 1px solid #F3EBE6;
      }
      &::before {
        content: "";
        ${tw`absolute left-0 w-2 h-2 rounded-full bg-primary-500`}
        top: 1.45rem;
      }
      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;
export default ({ headingText = "Privacy Policy" }) => {


  const { therapyType } = useParams();

  useEffect(() => {
    const element = document.getElementById(therapyType);
     if (therapyType===undefined){
      window.scrollTo(0, 0);
      return;
    }
     if (element) {
      // Check if the device is a mobile device
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (isMobile) {
        // Handle scrolling for mobile devices
        window.scrollTo({ top: element.offsetTop, behavior: 'smooth' });
      } else {
        // Handle scrolling for desktop browsers
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [therapyType]);

  return (
    <>    <GlobalStyle />

      <Header />
      <Container>
        <ContentWithPaddingXl>
        
          <Text>
          <h1>Therapie</h1>
           <p>In een tiental gesprekken van doorgaans 60 minuten behandelen we de klachten waarvoor je bent aangemeld. Binnen mijn praktijk kan dit door middel van cognitieve gedragstherapie, traumatherapie, psychotherapie en/of schrijftherapie.</p>
           <div className="container mx-auto flex justify-center items-center">
            <div className="flex justify-center mt-10">
              <img
                src={istockphoto}
                alt="Therapie"
                style={{ display: 'block', margin: '0 auto', maxWidth: '100%' }}
              />
            </div>
          </div>
            <h2 id="cgt">CGT</h2>
            Cognitieve gedragstherapie (CGT) is een bewezen en veelgebruikte therapie die goed werkt bij vrijwel alle mentale klachten. De therapie gaat ervan uit dat wat je voelt, denkt en doet elkaar beïnvloedt. We denken eigenlijk de hele dag door, maar doen dit veelal onbewust. Deze onbewuste gedachten, zeker als ze negatief zijn, hebben een enorme impact op ons dagelijks leven. Door de negatieve gedachten te herkennen, te toetsen en vervolgens aan te passen kunnen ook ons gevoel en gedrag veranderen.
            <h2 id="emdr-ie">Traumatherapie</h2>
            
            EMDR staat voor Eye Movement Desensitization and Reprocessing en wordt ingezet bij traumatische gebeurtenissen dan wel een posttraumatische stressstoornis (PTSS). Deze effectieve therapie is ooit gestart als het opnieuw verwerken en uitdoven van emoties door middel van snelle oogbewegingen. Inmiddels weten we dat het ook kan door middel van handbewegingen, het opnoemen van kleuren of zelfs het oplossen van rekensommen. Kortom alles waarbij het werkgeheugen belast wordt terwijl een beeld van het trauma wordt opgeroepen. IE staat voor imaginaire exposure (denkbeeldige blootstelling). Deze therapie gaat als het ware de confrontatie aan met de traumatische gebeurtenis door het onder begeleiding herhaaldelijk opnieuw te beleven. Door de blootstelling nemen de angst en negatieve emoties geleidelijk af.

           
            
            <h2 id="kpsp">KPSP</h2>
            KPSP staat voor kortdurende psychoanalytische steungevende psychotherapie. Deze therapie is voor mensen die kampen met depressieve klachten. Door wekelijkse gesprekken die je aanzetten tot actie zullen de depressieve symptomen verdwijnen. Ook zal de wijze waarop je naar jezelf en anderen kijkt veranderen en je zelfvertrouwen verbeteren.

            <h2 id="schrijftherapie">Schrijftherapie</h2>
            Schrijftherapie draait om het opschrijven van jouw gevoelens en gedachten. Deze therapievorm is voornamelijk effectief bij mensen die het lastig vinden hun gevoelens te uiten over een bepaalde gebeurtenis of persoon. Door bijvoorbeeld je levensverhaal op te schrijven of een brief te schrijven aan een persoon (zonder deze op te sturen) kun je gedachten en gevoelens leren uitspreken die je voorheen binnen hield.




            {/* <div className="container mx-auto flex justify-center items-center">
            <div className="flex justify-center mt-10">
              <img
                src={isstockphoto2}
                alt="Therapie"
                style={{ display: 'block', margin: '0 auto', maxWidth: '100%' }}
              />
            </div>
          </div> */}
           
            <h2 id="tarieven">Tarieven</h2>
            De maximumtarieven van de zorgprestaties worden elk jaar vastgesteld door de Nederlandse Zorgautoriteit (NZa). Het tarief per consult wordt bepaald door het type consult en de duur daarvan. Voor meer informatie kunt u terecht op <a href="https://nza.nl" target="_blank" rel="noopener noreferrer">nza.nl</a>. Psychologenpraktijk BB rekent de volgende tarieven voor de meest voorkomende consulten: 
             <ul>
  <li>Intake (o.b.v. 90 minuten) €300,39</li>
  <li>             Therapie (o.b.v. 60 minuten) €177,89</li>

</ul>


<br></br>

In 2026 heeft Psychologenpraktijk BB een contract met:

<ul>
  
  <li>a.s.r</li>
  <li>Caresq</li>
  <li>CZ</li>
  <li>DSW (incl. Stad Holland)</li>
  <li>Menzis (incl. VinkVink en AnderZorg)</li>
  <li>Salland</li>
  <li>VGZ (incl. Univé en ZEKUR)</li>
  <li>Zilveren Kruis (incl. FBTO, de Friesland en Interpolis)</li>
  <li>Zorg en Zekerheid</li>
  </ul>
  <br></br>
  
  Voor 2027 heeft Psychologenpraktijk BB een contract met:

<ul>
<li>a.s.r</li>
  <li>Caresq</li>
  <li>CZ</li>
  <li>DSW (incl. Stad Holland)</li>
  <li>Menzis (incl. VinkVink en AnderZorg)</li>
  <li>Salland</li>
  <li>VGZ (incl. Univé en ZEKUR)</li>
  <li>Zilveren Kruis (incl. FBTO, de Friesland en Interpolis)</li>
  <li>Zorg en Zekerheid</li>
  </ul>

            
Ben je boven de 18 jaar en heb je een verwijsbrief van de huisarts? Dan wordt de zorg 100% vergoed en de facturen direct naar jouw zorgverzekeraar verzonden. Ik werk volgens de Spelregel Planning = Realisatie.



<br></br>
<br></br>

Indien jouw zorgverzekeraar niet in het rijtje staat betekent dit dat de zorg deels vergoed wordt. Je ontvangt na elk bezoek van de praktijk een factuur met daarop de verschillende zorgprestaties. Deze factuur betaal je altijd zelf binnen 14 dagen volgens de algemene betalingsvoorwaarden van psychologenpraktijk BB. Je kunt deze factuur meteen na ontvangst al indienen bij de zorgverzekeraar.

<br></br>
            <br></br>
Ook als er geen sprake is van verzekerde zorg kan je in overleg met mij er toch voor kiezen om in behandeling te gaan. Hierbij kun je denken aan een diagnose zoals een aanpassingsstoornis (incl. overspanning en burn-out) die niet in het basispakket vergoed wordt. De kosten van deze behandeling zijn dan geheel voor eigen rekening.
Voor onverzekerde zorg is een verwijzing van de huisarts niet nodig. Check dit altijd eerst bij jouw zorgverzekeraar. 
<ul>

<li>            Onverzekerde zorg (o.b.v. 45 minuten directe tijd en 15 minuten indirecte tijd) €131,82

</li>
</ul>
<br></br>


          </Text>
        </ContentWithPaddingXl>
      </Container>
         <Footer />
       </>  );
};
